import Icon from '@ant-design/icons';
import { App, Flex, Tag } from 'antd';
import React from 'react';
import CustomCheckmarkIcon from '~/assets/svg/icon-checkmark.svg?react';
import CustomCopyPaste from '~/assets/svg/icon-copy-paste.svg?react';
import CustomCreditCardIcon from '~/assets/svg/icon-credit-card.svg?react';
import CustomShippingTruckIcon from '~/assets/svg/icon-shipping-truck.svg?react';
import CustomUnhappyIcon from '~/assets/svg/icon-smiley-unhappy.svg?react';
import ExternalLink from '~/components/shared/ExternalLink/ExternalLink';
import { formatShortDate, getStatusLabel, getStatusTagColor } from '~/helpers/conversation';
import { MerchantExternalRouting } from '~/helpers/general';

function ConversationOrderSummary({ user, order, merchant, contactReasonLabel, conversation }) {
  const { message } = App.useApp();
  return (
    <Flex vertical gap={4} className='body1'>
      {!user.deleted ? (
        <p className='body1'>
          <span className='text-grey-medium'>Prénom, Nom :</span> {user.first_name} {user.last_name}
        </p>
      ) : (
        <p className='body1'>Utilisateur supprimé</p>
      )}
      <Flex gap={8} align='center'>
        <span className='text-grey-medium'>N° de commande :</span> {order.id_number}
        <ExternalLink type='dark' href={MerchantExternalRouting.orderDetail(merchant.slug, order.id)} title='Détails de la commande' />
      </Flex>
      <p className='body1'>
        <span className='text-grey-medium'>Montant :</span> {order.amount}€
      </p>
      <Flex gap={8} align='center'>
        <Flex gap={4} align='center' title={order.created_on}>
          <Icon component={CustomCreditCardIcon} style={{ fontSize: 24 }} />
          <p className='body1'>Commandée : {formatShortDate(order.created_on)}</p>
        </Flex>
        <span className='text-grey'>/</span>
        {order.confirmed_on && (
          <>
            <Flex gap={4} align='center' title={order.confirmed_on}>
              <Icon component={CustomCheckmarkIcon} style={{ fontSize: 24 }} />
              <p className='body1'>Confirmée : {formatShortDate(order.confirmed_on)}</p>
            </Flex>
            <span className='text-grey'>/</span>
          </>
        )}
        {order.sent_on && (
          <Flex gap={4} align='center' title={order.sent_on}>
            <Icon component={CustomShippingTruckIcon} style={{ fontSize: 24 }} />
            <p className='body1'>Expédiée : {formatShortDate(order.sent_on)}</p>
          </Flex>
        )}
      </Flex>
      <Flex gap={8} align='center' wrap='wrap'>
        {order.tracking_url && (
          <Flex gap={8} align='center'>
            <ExternalLink href={order.tracking_url} title={`${order.transporter_name} (${order.tracking_number})`} bold />
            <CustomCopyPaste
              width='24px'
              height='24px'
              className='text-primary cursor-pointer'
              title='Copier le lien du suivi de colis'
              onClick={() => navigator.clipboard.writeText(order.tracking_url) && message.info('Lien copié')}
            />
          </Flex>
        )}
        {order.tracking_url && order.first_incident_on && <span className='text-grey'>/</span>}
        {order.first_incident_on && (
          <Flex gap={4} align='center' title={order.first_incident_on}>
            <CustomUnhappyIcon width='24' height='24' />
            <p className='body1'>Réclamation ouverte le : {formatShortDate(order.first_incident_on)}</p>
          </Flex>
        )}
        {contactReasonLabel && (
          <>
            {(order.tracking_url || order.first_incident_on) && <span className='text-grey'>/</span>}
            <Flex gap={4} align='center'>
              <span className='text-grey-medium'>Motif :</span>
              <Tag className='round light' color='default'>
                <b>{contactReasonLabel}</b>
              </Tag>
            </Flex>
          </>
        )}
        {conversation && (
          <>
            {(order.tracking_url || order.first_incident_on || contactReasonLabel) && <span className='text-grey'>/</span>}
            <Flex gap={4} align='center'>
              <span className='text-grey-medium'>Statut :</span>
              <Tag className='round light' color={getStatusTagColor(conversation)}>
                <b>{getStatusLabel(conversation)}</b>
              </Tag>
            </Flex>
          </>
        )}
      </Flex>
    </Flex>
  );
}

export default ConversationOrderSummary;
